import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

// Edit changes price, start date and end date only. The payer side and the
// product are immutable — see Form.js for why.
const Edit = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  onRefreshHandler,
  error,
  staleVersionError,
  submitting,
  defaultCoverageMaster,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    onRefreshHandler={onRefreshHandler}
    error={error}
    staleVersionError={staleVersionError}
    submitting={submitting}
    defaultCoverageMaster={defaultCoverageMaster}
    action='edit'
  />
);

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  onRefreshHandler: PropTypes.func,
  error: PropTypes.string,
  staleVersionError: PropTypes.string,
  submitting: PropTypes.bool,
  defaultCoverageMaster: PropTypes.object,
};

Edit.defaultProps = {
  isModalOpen: false,
  onRefreshHandler: null,
  error: null,
  staleVersionError: null,
  submitting: false,
  defaultCoverageMaster: null,
};

export default Edit;
